"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _PaymentFailedModule = _interopRequireDefault(require("./PaymentFailed.module.css"));

var _Button = _interopRequireDefault(require("../global/components/Button"));

var _CustomHR = _interopRequireDefault(require("./CustomHR"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// Modules
// Styles
// Components
var PaymentFailed = function PaymentFailed(props) {
  var message = props.message,
      practiceName = props.practiceName,
      practicePhone = props.practicePhone,
      callback = props.callback,
      gaEventHandlers = props.gaEventHandlers;

  var handleClick = function handleClick() {
    callback();
  };

  (0, _react.useEffect)(function () {
    if (typeof (gaEventHandlers === null || gaEventHandlers === void 0 ? void 0 : gaEventHandlers.load) === 'function') gaEventHandlers === null || gaEventHandlers === void 0 ? void 0 : gaEventHandlers.load();
    /**
     * We only want this to run once when the component loads
     * so it is safe to ignore the hooks/exhaustive-deps warning
     * eslint-disable-next-line
     */
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _PaymentFailedModule.default.container
  }, /*#__PURE__*/_react.default.createElement("header", {
    className: _PaymentFailedModule.default.header
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: _PaymentFailedModule.default.crossmark
  }, "\u2716"), /*#__PURE__*/_react.default.createElement("h3", null, "Payment failed")), /*#__PURE__*/_react.default.createElement(_CustomHR.default, null), /*#__PURE__*/_react.default.createElement("p", null, message), /*#__PURE__*/_react.default.createElement("p", null, "Please contact ", practiceName, " at", ' ', /*#__PURE__*/_react.default.createElement("a", {
    href: "tel:+1".concat(practicePhone)
  }, practicePhone), " to pay your outstanding balance"), /*#__PURE__*/_react.default.createElement(_Button.default, {
    clickHandler: handleClick,
    text: "Try again"
  }));
};

var _default = PaymentFailed;
exports.default = _default;